// @ts-nocheck
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { newsApi } from "../../../../api/news-api";
import { getText } from "../../../../utils/util";
import "./index.css";

export default function CenterPage({pledgeStatus}) {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  const [index, setIndex] = useState(1);
  const lan = localStorage.getItem("i18n");
  //杠杆隐藏
  const companyId = localStorage.getItem("companyId");
  //先取消隐藏
  const removeCompanyId = -1;


  return (
    <div className="container mx-auto bg-neutral-900 rounded-xl p-4 md:p-5 shadow-card animate-fade-in">
      {/* <h2 className="text-xl md:text-2xl font-bold text-white mb-5 px-2 border-l-4 border-primary">
        {translate(getText("交易中心"))}
      </h2> */}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div
          role="button"
          className="flex items-center justify-between p-3 md:p-4 bg-gradient-to-r from-neutral-800 to-neutral-900 rounded-lg hover:bg-gradient-primary transition-all duration-300 cursor-pointer border border-neutral-700 hover:border-primary-light shadow-lg group"
          onClick={() => {
            navigate(`/jyjlTrade`);
          }}
        >
          <div className="flex items-center">
            <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-primary/10 flex items-center justify-center mr-3 group-hover:bg-primary/50 transition-all duration-300">
              <svg
                className="w-4 h-4 md:w-5 md:h-5 text-primary group-hover:text-white transition-all duration-300"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M13 7H7v6h6V7z" />
                <path
                  fillRule="evenodd"
                  d="M7 2a1 1 0 012 0v1h2V2a1 1 0 112 0v1h2a2 2 0 012 2v2h1a1 1 0 110 2h-1v2h1a1 1 0 110 2h-1v2a2 2 0 01-2 2h-2v1a1 1 0 11-2 0v-1H9v1a1 1 0 11-2 0v-1H5a2 2 0 01-2-2v-2H2a1 1 0 110-2h1V9H2a1 1 0 010-2h1V5a2 2 0 012-2h2V2zM5 5h10v10H5V5z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            <span className="text-base md:text-lg text-white font-medium">
              {translate(getText("期權"))}
            </span>
          </div>
          <i className="fas fa-chevron-right text-primary-light group-hover:transform group-hover:translate-x-1 transition-all duration-300"></i>
        </div>

        {companyId != removeCompanyId && (
          <div
            role="button"
            className="flex items-center justify-between p-3 md:p-4 bg-gradient-to-r from-neutral-800 to-neutral-900 rounded-lg hover:bg-gradient-primary transition-all duration-300 cursor-pointer border border-neutral-700 hover:border-primary-light shadow-lg group"
            onClick={() => {
              navigate(`/jyjlLever2`);
            }}
          >
            <div className="flex items-center">
              <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-primary/10 flex items-center justify-center mr-3 group-hover:bg-primary/50 transition-all duration-300">
                <svg
                  className="w-4 h-4 md:w-5 md:h-5 text-primary group-hover:text-white transition-all duration-300"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M12 7a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0V8.414l-4.293 4.293a1 1 0 01-1.414 0L8 10.414l-4.293 4.293a1 1 0 01-1.414-1.414l5-5a1 1 0 011.414 0L11 10.586 14.586 7H12z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <span className="text-base md:text-lg text-white font-medium">
                {translate(getText("槓桿"))}
              </span>
            </div>
            <i className="fas fa-chevron-right text-primary-light group-hover:transform group-hover:translate-x-1 transition-all duration-300"></i>
          </div>
        )}

        <div
          role="button"
          className="flex items-center justify-between p-3 md:p-4 bg-gradient-to-r from-neutral-800 to-neutral-900 rounded-lg hover:bg-gradient-primary transition-all duration-300 cursor-pointer border border-neutral-700 hover:border-primary-light shadow-lg group"
          onClick={() => {
            navigate(`/lockUpOrder`);
          }}
        >
          <div className="flex items-center">
            <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-primary/10 flex items-center justify-center mr-3 group-hover:bg-primary/50 transition-all duration-300">
              <svg
                className="w-4 h-4 md:w-5 md:h-5 text-primary group-hover:text-white transition-all duration-300"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            <span className="text-base md:text-lg text-white font-medium">
              {translate(getText("鎖倉挖礦"))}
            </span>
          </div>
          <i className="fas fa-chevron-right text-primary-light group-hover:transform group-hover:translate-x-1 transition-all duration-300"></i>
        </div>

        {pledgeStatus == 1 && (
          <div
            role="button"
            className="flex items-center justify-between p-3 md:p-4 bg-gradient-to-r from-neutral-800 to-neutral-900 rounded-lg hover:bg-gradient-primary transition-all duration-300 cursor-pointer border border-neutral-700 hover:border-primary-light shadow-lg group"
            onClick={() => {
              navigate(`/repaymentList`);
            }}
          >
            <div className="flex items-center">
              <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-primary/10 flex items-center justify-center mr-3 group-hover:bg-primary/50 transition-all duration-300">
                <svg
                  className="w-4 h-4 md:w-5 md:h-5 text-primary group-hover:text-white transition-all duration-300"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M8.433 7.418c.155-.103.346-.196.567-.267v1.698a2.305 2.305 0 01-.567-.267C8.07 8.34 8 8.114 8 8c0-.114.07-.34.433-.582zM11 12.849v-1.698c.22.071.412.164.567.267.364.243.433.468.433.582 0 .114-.07.34-.433.582a2.305 2.305 0 01-.567.267z" />
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v.092a4.535 4.535 0 00-1.676.662C6.602 6.234 6 7.009 6 8c0 .99.602 1.765 1.324 2.246.48.32 1.054.545 1.676.662v1.941c-.391-.127-.68-.317-.843-.504a1 1 0 10-1.51 1.31c.562.649 1.413 1.076 2.353 1.253V15a1 1 0 102 0v-.092a4.535 4.535 0 001.676-.662C13.398 13.766 14 12.991 14 12c0-.99-.602-1.765-1.324-2.246A4.535 4.535 0 0011 9.092V7.151c.391.127.68.317.843.504a1 1 0 101.511-1.31c-.563-.649-1.413-1.076-2.354-1.253V5z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <span className="text-base md:text-lg text-white font-medium">
                {translate(getText("借幣"))}
              </span>
            </div>
            <i className="fas fa-chevron-right text-primary-light group-hover:transform group-hover:translate-x-1 transition-all duration-300"></i>
          </div>
        )}
      </div>
    </div>
  );
}
